import { Injectable, InjectionToken } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { User } from 'src/app/model/user';
import { UserWebResponse } from 'src/app/model/user-web-response';
import { Location } from 'src/app/model/location';

@Injectable()
export abstract class LocationDao {
    abstract getLocation(): any;
    abstract getLocationList(): Observable<any>;
    abstract addLocation(location): Observable<any>;
    abstract editLocation(location): Observable<any>;
    abstract getUserAPI(user): Observable<any>;
    abstract getTestUser(): Observable<any>;
    abstract login(user): Observable<any>;
    abstract forgotpassword(user): Observable<any>;
    abstract logout(user): Observable<any>;
}
